import React from "react";
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { BsCloudLightningFill, BsFacebook } from "react-icons/bs";
import { FaGithub, FaLinkedin } from "react-icons/fa";
import { FiInstagram, FiMail } from "react-icons/fi";
// import CV from "../../assets/resume.pdf";
import { bannerImg } from "../../assets/index";
import {DragCloseDrawerWrapper} from "../ui/DragCloseDrawer";

const Left = () => {
  const [text] = useTypewriter({
    words: ["Web Developer", "Full Stack Developer", "Frontend Developer", "Backend Developer"],
    loop: true,
    typeSpeed: 30,
    deleteSpeed: 20,
    delaySpeed: 2000,
  });
  return (
    <div className="w-full lgl:w-5/12 h-full bg-bodyColor rounded-2xl shadow-testShwdow ">
      <div className="w-full h-3/5 flex items-center justify-center">
        <img
          className="mt-8 lgl:mt-0 w-4/6 h-4/6 lgl:w-full lgl:h-full object-cover rounded-2xl outline outline-[0.5px] outline-designColor bg-slate-700/30"
          src={bannerImg}
          loading="priority"
          alt="bannerImage"
        />
      </div>
      <div className="w-full h-2/5 flex flex-col justify-between border-t-0 rounded-bl-xl rounded-br-xl">
        <div className="flex flex-col items-center gap-2 py-10">
          <h1 className="text-textColor text-4xl font-semibold">Syafiq Ibrahim</h1>
          <p className="text-base text-designColor tracking-wide">
            {text}
            <Cursor cursorBlinking="false" cursorStyle="|" />
          </p>
          <div className="flex justify-center gap-2 mt-2">
            <a href="https://github.com/Qifaysibr" className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <FaGithub />
            </a>
            <a href="https://www.linkedin.com/in/syafiq-ibrahim-7a8a89276/" className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <FaLinkedin />
            </a>
            <a href="https://www.facebook.com/syafiq.ibrahim.906/" className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <BsFacebook />
            </a>
            <a href="https://www.instagram.com/_afim_afim_/" className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <FiInstagram />
            </a>
            <span className="hover:text-designColor duration-300 cursor-pointer text-xl">
              <FiMail />
            </span>
          </div>
        </div>
        <div className="flex h-14 border-t-[1px] border-t-zinc-800">
          <a
            href="https://drive.google.com/file/d/1oEp6grmWG1l-YEpFxiTZLMGXGJX7gDdl/view?usp=sharing"
            target="_blank"
            rel="noreferrer"
            className="flex-1 flex justify-center items-center text-sm tracking-wide uppercase hover:text-designColor duration-300 border-r-zinc-800 border-r-[1px] hover:border-designColor hover:border-[1px] rounded-bl-xl"
          >
            Download CV <BsCloudLightningFill />
          </a>
          <div className="flex-1 flex justify-center items-center hover:border-designColor duration-300 hover:border-[1px] hover:text-designColor rounded-br-xl">
            <DragCloseDrawerWrapper />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Left;
